<div class="d-flex flex-row align-items-center flex-1">
  @if (props.resourceId || props.label) {
    <span class="italic d-inline-flex w-25">{{
      props.resourceId ? (props.resourceId | apmTranslate) : props.label
    }}</span>
  }
  @for (field of field.fieldGroup; track $index) {
    <div class="d-flex flex-row align-items-center justify-content-start flex-1">
      <formly-field class="flex-1" [field]="field"></formly-field>
    </div>
  }
</div>
